import request from '@/utils/server'
// 查询菜品列表
export function getDishList(query) {
    return request({
      url: '/dish/getDishList',
      method: 'get',
      params: query
    })
  }
// 新增菜品
export function add(data) {
  return request({
    url: '/dish/add',
    method: 'POST',
    data: data
  })
}
//   删除
  export function del(data) {
    return request({
      url: '/dish/del',
       method: 'POST',
      data: data
    })
  }
  
  
  // 修改
  export function edit(data) {
    return request({
      url: '/dish/edit',
      method: 'POST',
      data: data
    })
  }
  